import React from 'react';
import { Box, Button, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { RowAction } from '../../../../../components/row-action';
import { getAccountReportStatus } from '../../../../../model/sge/account-report/account-report-enums';
import { formatDate } from '../../../../../utils/date';
import { AmendmentDetailController } from '../context/amendment-detail-controller';
import { useAmendmentDetailState } from '../context/amendment-detail-context';
import { EmptyRow, dashIfEmpty } from './detail-parts';

export function AccountReportsTab({ ctrl }: { ctrl: AmendmentDetailController }) {
    const { accountReports } = useAmendmentDetailState();

    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
                <Button variant="contained" startIcon={<AddIcon />} onClick={() => ctrl.openAccountReportDrawer()}>Nova Prestação de Contas</Button>
            </Box>
            <TableContainer>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Período</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Observações</TableCell>
                            <TableCell align="right">Ações</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {accountReports.length === 0 && <EmptyRow colSpan={4} message="Nenhuma prestação de contas cadastrada" />}
                        {accountReports.map((report) => {
                            const status = getAccountReportStatus(report.status);
                            return (
                                <TableRow key={report.id} hover>
                                    <TableCell>{formatDate(report.periodStartDate)} - {formatDate(report.periodEndDate)}</TableCell>
                                    <TableCell>{status ? <Chip label={status.label} color={status.color} size="small" /> : '-'}</TableCell>
                                    <TableCell>{dashIfEmpty(report.observations)}</TableCell>
                                    <TableCell align="right">
                                        <Box sx={{ display: 'inline-flex' }}>
                                            <RowAction title="Editar" onClick={() => ctrl.openAccountReportDrawer(report)}><EditIcon fontSize="small" /></RowAction>
                                            <RowAction title="Excluir" color="error" onClick={() => ctrl.deleteAccountReport(report)}><DeleteIcon fontSize="small" /></RowAction>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </React.Fragment>
    );
}
